module.exports = __webpack_public_path__ + "static/coffee-1548766_1920 (1)_1-dbe9491cda995c8d05c2041d57928f25.jpg";